import type PlantModel from "Models/Plant";
import type VarietyModel from "Models/Variety";
import Modal from "react-modal";
import ModalStyle from "Assets/ModalStyle";
import { getPlantDisplayName } from "Helpers/PlantName";
import { formatLengthMeasurement } from "Helpers/UnitFormatter";

interface PlantDetailsModalProps {
  isOpen: boolean;
  plant?: PlantModel;
  plants: PlantModel[];
  varieties: VarietyModel[];
  companionPlantIds: string[];
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const PlantDetailsModal = ({
  isOpen,
  plant,
  plants,
  varieties,
  companionPlantIds,
  onClose,
  onEdit,
  onDelete,
}: PlantDetailsModalProps) => (
  <Modal
    style={ModalStyle.defaultStyle}
    ariaHideApp={false}
    isOpen={isOpen}
    onRequestClose={onClose}
  >
    <div className="m-50 p-5 text-center">
      <h3 className="text-4xl m-auto py-5 font-semibold">
        {getPlantDisplayName(plant, varieties)}
      </h3>
      <div className="md:grid-cols-2 md:grid-rows-2 grid-cols-1 grid-rows-1 gap-1 grid h-100">
        <div>
          <h3 className="text-lg py-5 font-semibold">Sun Requirement</h3>
          <p className="plant-info">{plant?.shadePreference}</p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Planting Info</h3>
          <p className="plant-info">{plant?.plantingInfo}</p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Companion Plants</h3>
          <p className="plant-info text-md">
            {plants
              .filter((candidate) => companionPlantIds.includes(candidate._id))
              .map((candidate) => getPlantDisplayName(candidate, varieties))
              .join(", ")}
          </p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Days to Germinate</h3>
          <p className="plant-info">{plant?.daysToGerminate}</p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Days to Maturity</h3>
          <p className="plant-info">{plant?.daysToMaturity}</p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Seed Depth</h3>
          <p className="plant-info">
            {formatLengthMeasurement(plant?.seedDepth, plant?.seedDepthUnit)}
          </p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Seed Spacing</h3>
          <p className="plant-info">
            {formatLengthMeasurement(
              plant?.seedSpacing,
              plant?.seedSpacingUnit,
            )}
          </p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">
            Light required to germinate
          </h3>
          <p className="plant-info">
            {plant?.lightRequiredToGerminate ? "Yes" : "No"}
          </p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Temperature Tolerance</h3>
          <p className="plant-info">{plant?.temperatureTolerance}</p>
        </div>
        <div>
          <h3 className="text-lg py-5 font-semibold">Water Requirement</h3>
          <p className="plant-info">{plant?.waterRequirement}</p>
        </div>
      </div>
      <div className="flex pt-10">
        <button onClick={onClose} className="ml-auto btn bg-gray-light mr-5">
          Cancel
        </button>
        <button onClick={onEdit} className="btn btn-green mr-auto">
          Edit
        </button>
        {plant && (
          <button onClick={onDelete} className="btn btn-danger">
            Delete
          </button>
        )}
      </div>
    </div>
  </Modal>
);

export default PlantDetailsModal;
